import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import $ from "jquery";
import {
  arrowDown,
  CloseCircular,
  crossIcon
} from "../../assets/images";
import "./index.scss";

$(".modal").on("hidden.bs.modal", function (e) {
  if ($(".modal").hasClass("in")) {
    $("body").addClass("modal-open");
  }
});

export default class CustomModal extends Component {
  render() {
    let {
      isOpen,
      toggleModal,
      disableBackdropToggle,
      hideCloseButton,
      size,
      containerStyle,
      title,
      titleClass,
      containerClass,
      key,
      filter,
      showMinimize,
      overLap,
      classname
    } = this.props;
    return isOpen ? (
      <div
        className={classnames(
          { modal__wrapperNew: size === "extrasmallgoback" },
          { overLapCss: overLap === true },
          "modal__wrapper",
          classname
        )}
        onClick={disableBackdropToggle ? null : toggleModal}
        key={key}
        id={"modalId"}
      >
        <div
          className={classnames(
            "modal__body",
            { modal__body__extralarge: size === "extralarge" },
            { modal__body__extrasmall: size === "extrasmall" },
            { modal__body__small: size === "small" },
            { modal__body__MessageDetail: size === "MessageDetail" },
            { modal__body__WideMessageDetail: size === "wideMessageDetail" },
            { modal__body__WideBannerDetail: size === "wideBannerDetail" },
            { modal__body__auditLogs: size === "auditLogs" },
            { extrasmall_Delete_Role: size === "DeleteRole" },
            { modal_preview: size === "preview" },
            { modal__body__smallPreview: size === "smallPreview" },
            { modal__body__imagePreview: size === "imagePreview" },
            { modal__body__profileImagePreview: size === "profileImagePreview" },
            { modal__body__templatePreview: size === "templatePreview" },
            { modal__body__notificationTemplate: size === "notificationTemplate" },
            { modal__body__newNotificationTemplate: size === "newNotificationTemplate" },
            { modal__body__notificationType: size === "notificationType" },
            { modal__body__emailPreview: size === "emailPreview" },
            containerClass
          )}
          onClick={(e) => e.stopPropagation()}
          style={containerStyle}
        >
          {title && (
            <p
              className={classnames("mb-0 font18Black boldFont", titleClass)}
              style={{ position: "absolute", top: "15px", left: "20px" }}
            >
              {title}
            </p>
          )}
          {hideCloseButton && (
            <img
              className="modal_close_button"
              onClick={toggleModal}
              src={filter ? crossIcon : CloseCircular}
              alt="close"
            />
          )}
          {showMinimize && (
            <img
              className="modal_close_button"
              onClick={toggleModal}
              src={arrowDown}
              alt="close"
            />
          )}
          {this.props.children}
        </div>
      </div>
    ) : null;
  }
}

CustomModal.defaultProps = {
  size: "medium",
};

CustomModal.propTypes = {
  children: PropTypes.element.isRequired,
  size: PropTypes.oneOf(["large", "medium", "small"]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  disableBackdropToggle: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
};
